import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsEmergencyContact } from '@/stores/userStore';

interface ProtectedRouteProps {
  children: ReactNode;
  requireEdit?: boolean;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireEdit = false,
  redirectTo = '/devices',
}) => {
  const isEmergencyContact = useIsEmergencyContact();

  // If this route requires edit permissions and user is emergency contact, redirect
  if (requireEdit && isEmergencyContact) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

const UnauthorizedPage: React.FC = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="text-center p-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Access Restricted</h2>
      <p className="text-gray-600 mb-6">
        You don't have permission to access this page. This action requires full account privileges.
      </p>
      <p className="text-sm text-gray-500">
        If you need to perform this action, please contact the account owner.
      </p>
    </div>
  </div>
);

export { ProtectedRoute, UnauthorizedPage };